<div class="top">
  <h2 mat-dialog-title>
    <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#token-s"></use></svg>
    Vælg brikker
  </h2>
  <a (click)="loadSelectedIdTags()" class="top__chosen">
    <div matBadge="{{ selectedIdTags.length }}" matBadgeOverlap="false">Valgt</div>
  </a>
  <a (click)="resetIdTags()" class="top__reset">Nulstil valg</a>
  <button class="btn-close btn-icon" mat-dialog-close>
    <mat-icon class="material-icons">close</mat-icon>
  </button>
</div>

<mat-dialog-content>
  <div class="actions" [formGroup]="filterModel">
    <mat-form-field class="actions__query">
      <mat-label>Søg brikker</mat-label>
      <input matInput placeholder="Navn, regnr. eller Brik ID" formControlName="query" />
      <mat-icon matSuffix>search</mat-icon>
    </mat-form-field>

    <mat-form-field class="actions__status">
      <mat-label>Vælg status</mat-label>
      <mat-select #statusSelect formControlName="selectedStatus" name="selectedStatus" okCustomDropDownArrowDirective>
        <mat-option [value]="null">Alle</mat-option>
        @for (status of statuses; track status) {
          <mat-option [value]="status">
            @if (status === idTagStatusEnum.Active) {
              Aktiv
            }
            @if (status === idTagStatusEnum.Inactive) {
              Inaktiv
            }
            @if (status === idTagStatusEnum.NoIdTagGroup) {
              Adgang fjernet
            }
            @if (status === idTagStatusEnum.Blocked) {
              Spærret
            }
          </mat-option>
        }
      </mat-select>
      <mat-icon matSuffix></mat-icon>
    </mat-form-field>

    <mat-form-field class="actions__departments">
      <mat-label>Vælg afdeling</mat-label>
      <mat-select #departmentSelect formControlName="selectedDepartmentId" okCustomDropDownArrowDirective>
        <mat-option [value]="null">Alle</mat-option>
        @for (department of departments; track department) {
          <mat-option [value]="department.id">
            {{ department.name }}
          </mat-option>
        }
      </mat-select>
      <mat-icon matSuffix></mat-icon>
    </mat-form-field>
  </div>
  <div>
    <div mat-dialog-content class="id-tag-selector">
      <adm-loading-spinner [loading$]="loading"></adm-loading-spinner>

      <mat-selection-list #idTagList [formControl]="idTagsCheckboxes">
        <div class="id-tag-selector__header">
          <div (click)="sortChange('printedId')">Id</div>
          <div (click)="sortChange('description')">Beskrivelse</div>
          <div (click)="sortChange('status')">Status</div>
          <div (click)="sortChange('departmentName')">Afdeling</div>
        </div>
        @for (idTag of idTagItems; track idTag) {
          <mat-list-option
            class="id-tag-selector__id-tag-item"
            checkboxPosition="after"
            [value]="idTag"
            [selected]="idTag.checked"
            (click)="idTagOptionWasClicked(idTag.id)">
            <div class="id-tag-selector__id-tag-item--printed-id">
              {{ idTag.printedId }}
            </div>
            <div class="id-tag-selector__id-tag-item--description">
              {{ idTag.description }}
            </div>
            <div class="id-tag-selector__id-tag-item--status">
              @if (idTag.status.toString() === idTagStatusEnum[idTagStatusEnum.Pending]) {
                <mat-chip class="secondary"> Afventer behandling </mat-chip>
              }
              @if (idTag.status.toString() === idTagStatusEnum[idTagStatusEnum.Active]) {
                <mat-chip class="success">Aktiv</mat-chip>
              }
              @if (idTag.status.toString() === idTagStatusEnum[idTagStatusEnum.Inactive]) {
                <mat-chip class="warn">Inaktiv</mat-chip>
              }
              @if (idTag.status.toString() === idTagStatusEnum[idTagStatusEnum.NoIdTagGroup]) {
                <mat-chip class="danger"> Adgang fjernet </mat-chip>
              }
              @if (idTag.status.toString() === idTagStatusEnum[idTagStatusEnum.Blocked]) {
                <mat-chip class="danger">Spærret</mat-chip>
              }
            </div>
            <div class="id-tag-selector__id-tag-item--department">
              @if (idTag.departmentName) {
                <span class="icon-with-text" title="Brikkens afdeling">
                  {{ idTag.departmentName }} <mat-icon svgIcon="business" class="icon muted"></mat-icon>
                </span>
              } @else if (idTag.chargingUserDepartmentName) {
                <span class="icon-with-text" title="Brugerens afdeling">
                  {{ idTag.chargingUserDepartmentName }} <mat-icon class="icon muted">person_outline</mat-icon>
                </span>
              }
            </div>
          </mat-list-option>
        }
      </mat-selection-list>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button class="actions__button" type="submit" mat-flat-button color="primary" (click)="saveAndClose()">Anvend</button>
</mat-dialog-actions>
